import React from "react";
const Tabs = ({ listStates, active, setActive }) => {
  return (
    <div className=" flex justify-center">
      <div className="flex rounded-lg bg-gray-100 p-1 transition dark:bg-zinc-700 dark:hover:bg-zinc-800">
        <nav className="flex">
          {/* <h4 className="text-md inline-flex items-center gap-2 px-4  py-1 font-[500] text-primary">
        States
      </h4> */}
          {listStates.map((state, i) => (
            <button
              type="button"
              className={`${
                state.value === active && "bg-white"
              } inline-flex items-center gap-3 rounded-md bg-transparent px-4 py-1 text-sm font-[400] text-gray-500 transition-all duration-700 dark:text-gray-400 dark:hover:bg-gray-500 dark:hover:text-gray-100`}
              onClick={() => {
                setActive(state.value);
              }}
              key={state.value}
              role="tab"
            >
              {state.name}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default Tabs;
